<template>
  <div class="single-alert">
    <div class="title">
      <slot name="title" />
    </div>
    <div
      class="message d-none d-md-block"
      :class="showForMobile ? 'd-block' : ''"
    >
      <slot name="message" />
    </div>
    <div class="alert-cta d-none d-md-block" v-if="showCta">
      <slot name="cta">
        <b-button variant="white" size="lg" :to="{ name: 'invoices' }">
          {{ $t('common.alert.viewInvoices') }}
        </b-button>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showCta: {
      type: Boolean,
      default: true
    },
    showForMobile: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables';
.single-alert {
  border-radius: $border-radius;
  background: $dc-error-bg-color;
  border: 1px solid $dc-error-border-color;
  border-left-width: 3px;
  padding: 1.2rem;
  box-shadow: $box-shadow-sm;
  margin-bottom: 1rem;
  font-family: $montserrat;
  .title {
    font-size: 1rem;
    font-weight: 600;
    color: $dc-error-border-color;
  }
  .message {
    flex-grow: 1;
    font-size: 1rem;
    line-height: 1.85rem;
    align-items: center;
    font-family: $lato;
    margin: 1rem 0;
  }
  .alert-cta {
    .btn-alert {
      background: $dc-error-border-color;
      color: white;
      font-size: 1rem;
      width: 100%;
    }
  }
  &:last-child {
    margin-bottom: 0;
  }
}
</style>
